//use a function for declaring module state to re init each time similar to data in component
export const state = () => ({
  dashboard: { LayoutV2: [] },
  widgetsByUUID: {},
  isWidgetMenuOpen: false,
  deletedWidgets: [],
  isLayoutChanged: false
});
